import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { log } from "../../Helper";
import { bindActionCreators } from "redux";
import * as loadBuildActionCreators from "../orders/actions";
import * as spinnerStateActionCreator from "../../formControl/actions";
import { useDispatch } from "react-redux";
import { Col } from "../../components/Layout";
import { Row } from "../../components/Layout";
import { toast } from "react-toastify";
import { requestLoadBuild } from "../orders/api";
import { formValidation } from "./validation";
import { TruckFormElements } from "./TruckFormElements";
import { VesselFormElements } from "./VesselFormElements";
import { FormSpinner } from "./FormSpinner";
import { SelectedMachinesTable } from "./selectedMachinesTable";
import { FormFileUpload } from "./FormFileUpload";
import { useUserInfo } from "../../common/user-context";
import dayjs from "dayjs";
import { TextareaAutosize } from "@mui/material";

function LoadBuildForm(props) {
  const { userData } = useUserInfo();

  const [selectedMachinesForBuild, setSelectedMachinesForBuild] = useState([]);
  const [startSpinner, setStartSpinner] = useState(false);
  const [freetext, setFreeText] = useState([]);
  const [totalWeight, setTotalWeight] = useState(0);
  const [avisDateError, setAvisDateError] = useState(false);
  const [estimatedArrivalDateError, setEstimatedArrivalDateError] =
    useState(false);
  const [truckplateError, setTruckPlateError] = useState(false);
  const [trailorplateError, setTrailorPlateError] = useState(false);
  const [driverNameError, setDriverNameError] = useState(false);
  const [portError, setPortError] = useState(false);
  const [blNumberError, setBlNumberError] = useState(false);
  const [containerNumberError, setContainerNumberError] = useState(false);
  const [sailDateError, setSailDateError] = useState(false);
  const [etaError, setEtaError] = useState(false);
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [triggerLoadBuildState, setTriggerLoadBuildState] = useState(false);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [loadingdSequence, setLoadingSequence] = useState(0);
  const [datesForHighlight, setDatesForHighlight] = useState("");
  const { triggerLoadBuildAction, loadBuildValidateAction } =
    bindActionCreators(loadBuildActionCreators, useDispatch());
  const { setSpinnerState } = bindActionCreators(
    spinnerStateActionCreator,
    useDispatch()
  );

  let triggerLoadBuild = useSelector(
    (storeState) => storeState.triggerLoadBuild
  );

  let sapSupplierNumber = useSelector((storeState) => storeState.setProvider);
  let supplierNumber = userData.supplierNumber;
  let userID = userData.userId;

  const handleCloseSpinner = (event, reason) => {
    if (reason !== "backdropClick") {
      setStartSpinner(false);
    }
  };

  const handleDrop = (acceptedFiles) => {
    setAcceptedFiles(acceptedFiles);
    setIsFileSelected(true);
    log("files", acceptedFiles);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);

    const validationMap = formValidation(data);
    validationMap.forEach((value, key) => {
      if (key === "avisDateError") {
        setAvisDateError(value);
        if (value === false) {
          validationMap.delete("avisDateError");
        }
      } else if (key === "estimatedArrivalDateError") {
        setEstimatedArrivalDateError(value);
        if (value === false) {
          validationMap.delete("estimatedArrivalDateError");
        }
      } else if (key === "truckPlateError") {
        setTruckPlateError(value);
        if (value === false) {
          validationMap.delete("truckPlateError");
        }
      } else if (key === "trailorPlateError") {
        setTrailorPlateError(value);
        if (value === false) {
          validationMap.delete("trailorPlateError");
        }
      } else if (key === "driverNameError") {
        setDriverNameError(value);
        if (value === false) {
          validationMap.delete("driverNameError");
        }
      } else if (key === "portError") {
        setPortError(value);
        if (value === false) {
          validationMap.delete("portError");
        }
      } else if (key === "blNumberError") {
        setBlNumberError(value);
        if (value === false) {
          validationMap.delete("blNumberError");
        }
      } else if (key === "containerNumberError") {
        setContainerNumberError(value);
        if (value === false) {
          validationMap.delete("containerNumberError");
        }
      } else if (key === "sailDateError") {
        setSailDateError(value);
        if (value === false) {
          validationMap.delete("sailDateError");
        }
      } else if (key === "etaError") {
        setEtaError(value);
        if (value === false) {
          validationMap.delete("etaError");
        }
      }
    });

    const transportMode = selectedMachinesForBuild[0].transportMode;
    if (validationMap.size === 0) {
      setStartSpinner(true);
      const orderPathId = [];
      const orderPathSequenceMap = new Map();
      for (var i = 0; i < selectedMachinesForBuild.length; i++) {
        orderPathId.push(selectedMachinesForBuild[i].orderPathId);
        // Ensure sequence is a valid number, default to "0" if not set or invalid
        const sequence = selectedMachinesForBuild[i].sequence && 
                        !isNaN(selectedMachinesForBuild[i].sequence) && 
                        selectedMachinesForBuild[i].sequence.toString().trim() !== ""
          ? selectedMachinesForBuild[i].sequence.toString() 
          : "0";
        orderPathSequenceMap.set(
          selectedMachinesForBuild[i].orderPathId,
          sequence
        );
      }
      log("Map for sequence", orderPathSequenceMap);
      log("selectedMachinesForBuild sequences", selectedMachinesForBuild.map(m => ({ 
        orderPathId: m.orderPathId, 
        sequence: m.sequence 
      })));

      const reqObj = {
        orderPathId: orderPathId,
        transportMode: transportMode,
        freetext: data.get("freetext"),
        trailerPlate: data.get("trailorplate"),
        truckPlate: data.get("truckplate"),
        avisDate: data.get("textField-datePicker-avisdate")
          ? dayjs(data.get("textField-datePicker-avisdate")).format(
              "YYYY-MM-DDTHH:mm"
            )
          : "",
        estimatedArrivalDate: data.get(
          "textField-datePicker-estimatedArrivalDate"
        )
          ? dayjs(data.get("textField-datePicker-estimatedArrivalDate")).format(
              "YYYY-MM-DDTHH:mm"
            )
          : "",
        providerId: selectedMachinesForBuild[0].providerId,
        driverName: data.get("driverName"),
        imoNumber: data.get("vessel")
        ? String(data.get("vessel").match(/\((\d+)\)/)?.[1] ?? '').trim() // Extract number from the format
        : '', // Trim and extract only numbers as string
        portOfEntryId: data.get("portOfEntry"),
        portOfExitId: data.get("portOfExit"),
        blNumber: data.get("blNumber"),
        containerNumber: data.get("containerNumber"),
        sailDate: data.get("sailDate")
          ? dayjs(data.get("sailDate")).format("YYYY-MM-DD")
          : "",
        vesselETA: data.get("eta")
          ? dayjs(data.get("eta")).format("YYYY-MM-DD")
          : "",
        sapSupplierNumber: _.isEmpty(sapSupplierNumber)
          ? supplierNumber
          : sapSupplierNumber,
        userID: userID,
        orderPathSequenceMap: Object.fromEntries(orderPathSequenceMap),
      };
      log("selectedMachinesBuild", selectedMachinesForBuild);
      log("data", data);
      log("request object", reqObj);

      getLoadBuildResponse(reqObj, acceptedFiles);
    } else {
      triggerLoadBuildAction(false);
      loadBuildValidateAction(false);
    }
  };

  async function getLoadBuildResponse(reqObj, acceptedFiles) {
    const response = await requestLoadBuild(reqObj, acceptedFiles);
    setSpinnerState(false);
    setStartSpinner(false);
    loadBuildValidateAction(true);
    triggerLoadBuildAction(false);

    if (response["status"] == 200) {
      toast.success("Selected orders are marked for load successfully");
    } else if (response["status"] == 409) {
      toast.warn("Error Occurred");
    } else if (response["status"] == 206) {
      toast.success("Load build successful");
      toast.warn("File upload failed");
    } else if (response["status"] == 400) {
      toast.error("Machine is already in load build");
    } else {
      toast.error("Load Build failed");
    }
  }

  useEffect(() => {
    setTriggerLoadBuildState(triggerLoadBuild);
  });

  useEffect(() => {
    if (triggerLoadBuildState) {
      submitForm.click();
    }
  }, [triggerLoadBuildState]);

  useEffect(() => {
    let machine = [];
    let tempFreetext = [];
    let totalWeight = 0;

    for ( let i = 0; i < Object.keys(props.selectedMachinesForBuild).length; i++) {
      machine.push(props.selectedMachinesForBuild[i]);
      // Set sequence to 0 for all machines by default
      machine[i].sequence = "0";
      tempFreetext = _.concat(tempFreetext, props.selectedMachinesForBuild[i].freetext);
      totalWeight = totalWeight + parseInt(props.selectedMachinesForBuild[i].weight);
    }
    setTotalWeight(totalWeight);
    setFreeText(tempFreetext.filter(Boolean).join("\n"));
    setSelectedMachinesForBuild(machine);

    //if more than one machine is load build then it will concate the dates and given for highlight
    if (machine.length > 1) {
      const concatenatedDates = machine
        .map((machineData) => machineData.highlightedDatesForPickUp)
        .join(", ");
      setDatesForHighlight(concatenatedDates);
    } else {
      setDatesForHighlight(machine[0].highlightedDatesForPickUp);
    }
  }, []);

  const handleSequenceUpdate = (orderPathId, newSequence) => {
    setSelectedMachinesForBuild(prevMachines => 
      prevMachines.map(machine => 
        machine.orderPathId === orderPathId 
          ? { ...machine, sequence: newSequence }
          : machine
      )
    );
  };

  let submitForm = "";
  return (
    <div className=" p-3">
      <form onSubmit={handleSubmit} className="text-md">
        <Row className="gap-6">
          <Col className="flex-1">
            {(props.selectedMachinesForBuild[0].transportMode === "VESSEL" 
              || props.selectedMachinesForBuild[0].transportMode === "FERRY") ? (
              <VesselFormElements
                portError={portError}
                sailDateError={sailDateError}
                etaError={etaError}
                blNumberError={blNumberError}
                containerNumberError={containerNumberError}
                portOfExitList={props.locationList}
                portOfEntryList={props.locationList}
                vesselList={props.imoList}
              />
            ) : (
              <TruckFormElements
                avisDateError={avisDateError}
                truckplateError={truckplateError}
                trailorplateError={trailorplateError}
                driverNameError={driverNameError}
                estimatedArrivalDateError={estimatedArrivalDateError}
                truckplateList={
                  props.selectedMachinesForBuild[0].truckDetailsDTOList
                }
                highlightedDates={datesForHighlight}
              />
            )}
          </Col>

          <Col className="flex-1">
            <label className="text-xs">
              Additional Information (Shipping Order)
            </label>
            {/* <br /> */}
            <textarea
              style={{ fontSize: 12, width: "100%" }}
              className="text-xs mt-1 mb-2 p-2 w-full border-gray-500 border rounded-sm"
              placeholder="Please enter additional instuctions here.."
              name="freetext"
              rows={3}
              defaultValue={freetext}
              maxLength="400"
            ></textarea>

            <FormFileUpload onDrop={handleDrop} fileSelected={isFileSelected} />
          </Col>
        </Row>

        <input
          className=" invisible"
          ref={(input) => {
            submitForm = input;
          }}
          type="submit"
        />
      </form>

      <FormSpinner
        openFormSpinner={startSpinner}
        closeFormSpinner={handleCloseSpinner}
      />
      <br />
      <SelectedMachinesTable
        selectedMachines={selectedMachinesForBuild}
        weight={totalWeight}
        onSequenceUpdate={handleSequenceUpdate}
      />
    </div>
  );
}

export default LoadBuildForm;
